import { Router, type CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);

  if (!auth.isAuthenticated()) {
    auth.login(state.url);
    return false;
  }

  const requiredRoles = auth.getRequiredRoles(route);
  if (!auth.hasRequiredRoles(requiredRoles)) {
    return router.parseUrl('/forbidden');
  }

  return true;
};
